import * as actions from './contraEntry/actions'
import * as mutations from './contraEntry/mutations'
import * as getters from './contraEntry/getters'

import { dataProps } from './contraEntry/properties'

const state = {
    list: [],
    nav: {
        page_number: 1, had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.id',
        sort_direction: 1, search_term: '', 
        search_term_array: [],
        total_amount: 0    
    },
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/contraEntry.js